import React, { useEffect } from "react";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import RanglisteContainer from "../../components/rangliste/rangliste.container";
import { connect } from "react-redux";
import { fetchGemeindelisteStart } from "../../redux/gemeinde/gemeinde.actions";
import moment from "moment";
import { Typography } from "@material-ui/core";

const RanglistePage = ({ fetchGemeindelisteStart }) => {
  useEffect(() => {
    fetchGemeindelisteStart();
  }, [fetchGemeindelisteStart]);
  return (
    <div>
      <PageHeaderComponent
        title="Rangliste"
        subtitle="so stehen die Gemeinden..."
      />
      <Typography variant="h6">Stand: {moment().format("l")}</Typography>
      <RanglisteContainer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchGemeindelisteStart: () => dispatch(fetchGemeindelisteStart()),
});

export default connect(null, mapDispatchToProps)(RanglistePage);
